// extracted by mini-css-extract-plugin
module.exports = {"thresholdTextField":"NewCommentersConfig-thresholdTextField-14b3215148bbd10b295fc0a74932bdbf"};